/* eslint react/no-direct-mutation-state: "off", eqeqeq: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import { Button, Table, Modal } from 'reactstrap';
import { GetTenantInvoiceDetails, GenerateInvoice, GenerateSummaryInvoice, GenerateExcelSummaryInvoice, GenerateExcelInvoice } from '../../../../../action/invoiceAction';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Currencies from '../../../../../Resources/Currencies';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import InvoiceDetail from '../Invoices/InvoiceDetail';
import RedirectionConfirmation from '../_ModalsForms/RedirectionConfirmation';
import classnames from 'classnames';
import Conversions from '../../../../../Resources/Conversions';
import { setAmplitudeEvent } from 'amplitude/amplitude';
import LoadingIndicator from '../../../Common/LoadingIndicator';

class PrepareInvoice extends Component {
    componentWillMount() {
        if (this.props.userIDs != undefined && this.props.userIDs.tenantIds.length > 0) {
            localStorage.setItem("userIDs", JSON.stringify(this.props.userIDs));
        }
    }

    componentDidMount() {
        var TenantIDs = null;
        if (this.props.userIDs != undefined) {
            TenantIDs = this.props.userIDs
        }
        else if (localStorage.getItem('userIDs') != undefined) {
            TenantIDs = localStorage.getItem('userIDs');
            TenantIDs = JSON.parse(TenantIDs);
        }
        if (TenantIDs != null)
            this.props.GetTenantInvoiceDetails(TenantIDs).then(() => this.setState({isloading: false}));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ tenants_invoice_data_in_state: nextProps.TenantInvoiceDetails.data });
        }
    }

    componentDidUpdate = () => {
        if (this.state.isBlocking) {
            window.onbeforeunload = () => true
        } else {
            window.onbeforeunload = undefined
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            tenants_invoice_data_in_state: null,
            start_date: this.GetPreviousMonthStartDate(),
            end_date: this.GetPreviousMonthEndDate(),
            customizeinvoiceRedirect: false,
            redirectHome: false,
            IsErrorComparision: false,
            IsErrorMandatory: false,
            ManualvalidStartDate: true,
            IsModel: false,
            IsConfirmationModel: false,
            SelectedTenantId: 0,
            SelectedTenantName: '',
            SelectedUsage: [],
            SelectedFixed: [],
            Currency: 0,
            isBlocking: false,
            btnBackClicked: false,
            btnCustomClicked: false
        };
        this.ApplyDateRange = this.ApplyDateRange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.ShowInvoiceDetails = this.ShowInvoiceDetails.bind(this);
        this.toggle = this.toggle.bind(this);
        this.GoBack = this.GoBack.bind(this);
        this.HandleToUpdate = this.HandleToUpdate.bind(this);
        this.Actiontoggle = this.Actiontoggle.bind(this);
        this.GenerateInvoice = this.GenerateInvoice.bind(this);
        this.GenerateExcelInvoice = this.GenerateExcelInvoice.bind(this);
        this.GenerateSummaryInvoice = this.GenerateSummaryInvoice.bind(this);
        this.GenerateExcelSummaryInvoice = this.GenerateExcelSummaryInvoice.bind(this);
    }

    HandleToUpdate(usage_data, fixed_data, afterhour_total, block) {
        let temp_data = this.state.tenants_invoice_data_in_state;
        temp_data.forEach(element => {
            if (element.tenantId == this.state.SelectedTenantId) {
                element.adjustedTotal = parseFloat(afterhour_total);
                element.consumptionDetails = usage_data;
                element.fixedChargeDetails = fixed_data;
            }
        });

        this.setState({
            tenants_invoice_data_in_state: temp_data,
            IsModel: !this.state.IsModel,
            isBlocking: block
        });
    }

    ShowInvoiceDetails(id, name) {
        this.state.SelectedTenantId = id;
        this.state.SelectedTenantName = name;
        this.state.Currency = this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id).length > 0 ? this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id)[0].currencyId : this.state.Currency;
        this.state.SelectedUsage = this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id).length > 0 ? this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id)[0].consumptionDetails : [];
        this.state.SelectedFixed = this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id).length > 0 ? this.state.tenants_invoice_data_in_state.filter(x => x.tenantId == id)[0].fixedChargeDetails : [];
        this.toggle();
    }

    GoBack() {
        this.setState({
            redirectHome: !this.state.isBlocking,
            IsConfirmationModel: this.state.isBlocking,
            btnBackClicked: true,
            btnCustomClicked: false
        });
    }

    toggle() {
        this.setState({
            IsModel: !this.state.IsModel
        });
    }

    handleChange(date) {
        if (date != null) {
            this.setState({
                start_date: date
            });
        }
    }





    checkStartDate(e) {
        var parts = e.target.value.split("/");
        var year = parseInt(parts[2], 10);

        if (year > 1000 || year < 3000) {
            if (moment(e.target.value, 'MM/DD/YYYY', true).isValid()) {
                this.state.start_date = new Date(e.target.value)
            }
        }
    }

    checkEndDate(e) {
        var parts = e.target.value.split("/");
        var year = parseInt(parts[2], 10);

        if (year > 1000 || year < 3000) {
            if (moment(e.target.value, 'MM/DD/YYYY', true).isValid()) {
                this.state.end_date = new Date(e.target.value)
            }
        }
    }

    handleEndDateChange(date) {
        if (date != null) {
            this.setState({
                end_date: date
            });
        }
    }

    ApplyDateRange() {
        this.setState({ IsErrorComparision: false });
        if (!this.state.isBlocking) {
            let l_Start = this.FormDateForValidation(this.state.start_date);
            let l_End = this.FormDateForValidation(this.state.end_date);

            if (this.IsValidateDate(l_Start) && this.IsValidateDate(l_End) && !this.state.IsErrorMandatory) {
                if (this.state.start_date < this.state.end_date) {
                    var Apply_Param = {
                        "tenantIds": this.props.userIDs.tenantIds,
                        "startDate": this.FormValidDate(this.state.start_date),
                        "endDate": this.FormValidDate(this.state.end_date)
                    }

                    this.props.GetTenantInvoiceDetails(Apply_Param);
                }
                else {
                    this.setState({
                        IsErrorComparision: true
                    });
                }
            }
            else {
                this.setState({
                    IsErrorMandatory: true
                });
            }
        }
        else {
            this.setState({
                IsConfirmationModel: this.state.isBlocking,
                btnBackClicked: false,
                btnCustomClicked: false
            });
        }
    }

    IsValidateDate = (dateString) => {
        var parts = dateString.split("/");
        var year = parseInt(parts[2], 10);

        if (year < 1000 || year > 3000)
            return false;

        if (!moment(dateString, 'MM/DD/YYYY', true).isValid())
            return false;

        return true;
    }

    CloseModal = () => {
        this.toggle();
    }

    GetPreviousMonthStartDate() {
        var date = new Date();
        return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    }

    GetPreviousMonthEndDate() {
        var date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 0);
    }

    FormValidDate = (date) => {
        return (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " 00:00:00")
    }

    FormDateForValidation(date) {
        let l_month = (Number((date.getMonth() + 1)) > 9) ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1);
        let l_date = (Number(date.getDate()) > 9) ? date.getDate() : "0" + date.getDate();
        let l_Year = date.getFullYear();
        return l_month + "/" + l_date + "/" + l_Year;
    }

    /*Redirect to Customise Invoice*/

    customizeInvoice() {
        this.setState({
            customizeinvoiceRedirect: !this.state.isBlocking,
            IsConfirmationModel: this.state.isBlocking,
            btnCustomClicked: true,
            btnBackClicked: false,
        });
    }

    Action = (returnVal) => {
        if (returnVal == "yes") {
            if (this.state.btnCustomClicked) {
                this.setState({ customizeinvoiceRedirect: true, btnCustomClicked: false, isBlocking: false });
            }
            else if (this.state.btnBackClicked) {
                this.setState({ btnCustomClicked: false, redirectHome: true, isBlocking: false });
            }
            else {
                this.setState({ isBlocking: false });

                let l_Start = this.FormDateForValidation(this.state.start_date);
                let l_End = this.FormDateForValidation(this.state.end_date);

                if (this.IsValidateDate(l_Start) && this.IsValidateDate(l_End) && !this.state.IsErrorMandatory) {
                    if (this.state.start_date < this.state.end_date) {
                        var Apply_Param = {
                            "tenantIds": this.props.userIDs.tenantIds,
                            "startDate": this.FormValidDate(this.state.start_date),
                            "endDate": this.FormValidDate(this.state.end_date)
                        }
                        this.props.GetTenantInvoiceDetails(Apply_Param);
                    }
                    else {
                        this.setState({
                            IsErrorComparision: true
                        });
                    }
                }
                else {
                    this.setState({
                        IsErrorMandatory: true
                    });
                }
            }

        }
        this.Actiontoggle();
    }

    Actiontoggle() {
        this.setState({ IsConfirmationModel: !this.state.IsConfirmationModel });
    }


    GenerateInvoice() {
        var data = [], lineitem = '';
        this.state.tenants_invoice_data_in_state.forEach(element => {
            lineitem = {
                "tenantId": element.tenantId,
                "startDate": this.state.start_date, //this.FormValidDate(this.state.start_date),
                "endDate": this.state.end_date, //this.FormValidDate(this.state.end_date),
                "meterCharges": element.consumptionDetails.length > 0 ? element.consumptionDetails : null,
                "fixedCharges": element.fixedChargeDetails.length > 0 ? element.fixedChargeDetails : null
            }
            data.push(lineitem);
        });
        const eventProperties = { "Invoice Format": "Excel", "Invoices Downloaded": data.length }
        setAmplitudeEvent("Generate Invoice", eventProperties);
        data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.GenerateInvoice(arrayItem)), Promise.resolve());
    }


    GenerateExcelInvoice() {
        var data = [], lineitem = '';
        this.state.tenants_invoice_data_in_state.forEach(element => {
            lineitem = {
                "tenantId": element.tenantId,
                "startDate": this.state.start_date, //this.FormValidDate(this.state.start_date),
                "endDate": this.state.end_date, //this.FormValidDate(this.state.end_date),
                "meterCharges": element.consumptionDetails.length > 0 ? element.consumptionDetails : null,
                "fixedCharges": element.fixedChargeDetails.length > 0 ? element.fixedChargeDetails : null
            }
            data.push(lineitem);
        });

        const eventProperties = { "Invoice Format": "Excel", "Invoices Downloaded": data.length }
        setAmplitudeEvent("Generate Invoice", eventProperties);
        data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.GenerateExcelInvoice(arrayItem)), Promise.resolve());
    }

    GenerateSummaryInvoice() {
        var data = [{
            "startDate": this.state.start_date, //this.FormValidDate(this.state.start_date),
            "endDate": this.state.end_date,
            tenantDetails: []
        }]

        this.state.tenants_invoice_data_in_state.forEach(element => {
            var lineitem = {
                "tenantId": element.tenantId,
                "currencySymbol": Currencies.CurrencySymbol(element.currencyId),
                "tenantName": element.tenantName,
                "invoiceTotalAmount": Number(element.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0) + element.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0) + element.adjustedTotal).toFixed(2),
                "afterHoursTotal": Number(element.adjustedTotal).toFixed(2),
                "fixedChargesTotal": Number(element.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0)).toFixed(2),
                "meterChargesTotal": Number(element.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0)).toFixed(2)
            }
            data[0].tenantDetails.push(lineitem);
        });
        setAmplitudeEvent("Generate Summary Report", { "Invoice Format": "PDF" });
        this.props.GenerateSummaryInvoice(data[0]);
    }

    GenerateExcelSummaryInvoice() {
        var data = [{
            "startDate": this.state.start_date, //this.FormValidDate(this.state.start_date),
            "endDate": this.state.end_date,
            tenantDetails: []
        }]
        this.state.tenants_invoice_data_in_state.forEach(element => {
            var lineitem = {
                "tenantId": element.tenantId,
                "currencySymbol": Currencies.CurrencySymbol(element.currencyId),
                "tenantName": element.tenantName,
                "invoiceTotalAmount": Number(element.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0) + element.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0) + element.adjustedTotal).toFixed(2),
                "afterHoursTotal": Number(element.adjustedTotal).toFixed(2),
                "fixedChargesTotal": Number(element.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0)).toFixed(2),
                "meterChargesTotal": Number(element.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0)).toFixed(2)
            }
            data[0].tenantDetails.push(lineitem);
        });
        setAmplitudeEvent("Generate Summary Report", { "Invoice Format": "Excel" });
        this.props.GenerateExcelSummaryInvoice(data[0]);
    }

    render(TenantInvoiceDetails, getLabels, UserPreference_response) {


        if (this.state.customizeinvoiceRedirect) {
            return <Redirect to={"/Invoices/invoicesetup"} />
        }
        if (this.state.redirectHome) {
            return <Redirect to={"/managetenant"} />
        }

        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;
        let UserFormat = Conversions.UserPreferenceDateFormat_DatePicker(PreferedDateFormat);

        let Tenant_Invoice_Details, Meter_charge_Total, errorText = '';  //eslint-disable-line

        if (this.state.start_date == null) {

        }

        if (this.state.IsErrorComparision) {
            errorText = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />
                {label['CreateTenant.GreaterThan.Text'] !== undefined ? label['CreateTenant.GreaterThan.Text'] : "Error: From date should not be greater than the To Date.  Review and correct any fields with ! next to them."}
            </p>
        }

        if (this.state.IsErrorMandatory) {
            errorText = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />
                {label['CreateTenant.EmptyError.Text'] !== undefined ? label['CreateTenant.EmptyError.Text'] : "Error: You left necessary fields blank or entered invalid values.  Review and correct any fields with ! next to them."}
            </p>
        }

        if (this.state.tenants_invoice_data_in_state != null && this.state.tenants_invoice_data_in_state.length > 0 && !this.state.isloading) {
            Tenant_Invoice_Details = this.state.tenants_invoice_data_in_state.map((el, j) => {
                Meter_charge_Total = 0
                let AFHourTot = Number(el.adjustedTotal).toFixed(2);
                let UsageTot = Number(el.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0)).toFixed(2);
                let FixedTot = Number(el.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0)).toFixed(2);
                let Total = Number(el.consumptionDetails.reduce((prev, next) => prev + (next.totalUsageAmount * (next.rate > 0 ? next.rate : 1)), 0) + el.fixedChargeDetails.reduce((prev, next) => prev + parseFloat(next.fixedRate), 0) + el.adjustedTotal).toFixed(2);
                return <tr key={el.tenantId}>
                    <td ><p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ShowInvoiceDetails(el.tenantId, el.tenantName) }} >{el.tenantName}</p></td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat, AFHourTot)}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}
                        {
                            Conversions.formatNumber(PreferedDateFormat, UsageTot)
                        }
                    </td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat, FixedTot)}</td>
                    <td style={{ textAlign: "right" }}>{Currencies.CurrencySymbol(el.currencyId)}{' '}{Conversions.formatNumber(PreferedDateFormat, Total)}</td>
                </tr>
            });
        }else {
            Tenant_Invoice_Details = <tr><td colSpan="5" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr> 
        }

        return (
            <div className="main_container" style={{ "max-height": "80vh", "overflow-y": "auto" }}>
                <h2 className="page_title inv_pagetitle">{label['TenantBillingPreview.PageTitle.Text'] !== undefined ? label['TenantBillingPreview.PageTitle.Text'] : "Prepare Invoice"}</h2>

                {errorText}

                <div className="buttons_container">
                    <Button type="button" className="btn btn-success" onClick={() => { this.customizeInvoice() }} >{label['InoviceSetup.PageTitle.Text'] !== undefined ? label['InoviceSetup.PageTitle.Text'] : "Customize Invoice"}   </Button> <br /><br />
                    <Button type="button" className="btn btn-black" onClick={this.GenerateInvoice} >{label['TenantBillingPreview.GenerateInvoicePDFs.Text'] !== undefined ? label['TenantBillingPreview.GenerateInvoicePDFs.Text'] : "Generate Invoice PDFs"}   </Button>
                    <Button type="button" className="btn btn-black" onClick={this.GenerateExcelInvoice} >{"Generate Invoice Excel"}   </Button>
                    <Button type="button" className="btn btn-black" onClick={this.GenerateSummaryInvoice} >{"Generate Summary Report"}</Button>
                    <Button type="button" className="btn btn-black" onClick={this.GenerateExcelSummaryInvoice} >{" Generate Excel report"}</Button>
                </div>

                <div>
                    <p style={{ fontFamily: 'Verdana', fontSize: '12px' }}><b>{label['TenantBillingPreview.DateFilter.Text'] !== undefined ? label['TenantBillingPreview.DateFilter.Text'] : "Select Date Range for Invoice Detail"}</b></p>
                </div>

                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td style={{ width: "100px" }}>
                                    <label className="Custom_table">{label['TenantBillingPreview.FromDate.Text'] !== undefined ? label['TenantBillingPreview.FromDate.Text'] : "From Date"}</label>
                                </td>
                                <td style={{ width: "80px" }}>
                                    <DatePicker selected={this.state.start_date} dateFormat={UserFormat} onChange={this.handleChange} />
                                </td>
                                <td style={{ width: "100px" }}>
                                    <label className="Custom_table">{label['TenantBillingPreview.ToDate.Text'] !== undefined ? label['TenantBillingPreview.ToDate.Text'] : "To Date"}</label>
                                </td>
                                <td style={{ width: "80px" }}>
                                    <DatePicker selected={this.state.end_date} dateFormat={UserFormat} onChange={this.handleEndDateChange} />
                                </td>
                                <td>
                                    <Button type="button" className="btn btn-black" onClick={this.ApplyDateRange} >{label['CreateTenant.Apply.Text'] !== undefined ? label['CreateTenant.Apply.Text'] : "Apply"}   </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div className="table_container">
                    <Table striped responsive className=" Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th>{label['TenantBillingPreview.Columns.Tenant.Text'] !== undefined ? label['TenantBillingPreview.Columns.Tenant.Text'] : "Tenant"}</th>
                                <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.AfterHoursCharges.Text'] !== undefined ? label['TenantBillingPreview.AfterHoursCharges.Text'] : "After-Hours Charges"}</th>
                                <th style={{ textAlign: "right" }}> {label['TenantBillingPreview.UsageCharges.Text'] !== undefined ? label['TenantBillingPreview.UsageCharges.Text'] : "Usage Charges"}</th>
                                <th style={{ textAlign: "right" }}> {label['TenantBillingPreview.FixedCharges.Text'] !== undefined ? label['TenantBillingPreview.FixedCharges.Text'] : "Fixed Charges"}</th>
                                <th style={{ textAlign: "right" }}>{label['TenantBillingPreview.TotalCharges.Text'] !== undefined ? label['TenantBillingPreview.TotalCharges.Text'] : "Total Charges"}</th>
                            </tr>
                            {Tenant_Invoice_Details}
                        </tbody>
                    </Table>
                </div>
                <br></br>
                <div className="buttons_container">
                    <Button type="button" className="btn btn-gray" onClick={this.GoBack} >{label['Wizards.BackButton.Text'] !== undefined ? label['Wizards.BackButton.Text'] : "< Back"}   </Button>
                </div>

                <Modal isOpen={this.state.IsModel} toggle={this.toggle} className='InvoiceDetails_modal' style={{ maxwidth: '80%' }} >
                    <InvoiceDetail TenantId={[this.state.SelectedTenantId]} TenantName={[this.state.SelectedTenantName]} FromDate={this.state.start_date} ToDate={this.state.end_date} Usage={JSON.stringify(this.state.SelectedUsage)} Fixed={JSON.stringify(this.state.SelectedFixed)} Currency={[this.state.Currency]} CloseModal={this.CloseModal} handleToUpdate={this.HandleToUpdate} />
                </Modal>

                <Modal isOpen={this.state.IsConfirmationModel} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <RedirectionConfirmation parentToChildData={["Leave site?", "Changes you made may not be saved"]} Action={this.Action} No={["Cancel"]} Yes={["Leave"]} />
                </Modal>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        userIDs: state.tenantsRootReducer.TenantsForInvoice.userIDs,
        TenantInvoiceDetails: state.InvoiceRootReducer.TenantInvoiceDetails,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTenantInvoiceDetails: (data) => dispatch(GetTenantInvoiceDetails(data)),
        GenerateInvoice: (data) => dispatch(GenerateInvoice(data)),
        GenerateSummaryInvoice: (data) => dispatch(GenerateSummaryInvoice(data)),
        GenerateExcelSummaryInvoice: (data) => dispatch(GenerateExcelSummaryInvoice(data)),
        GenerateExcelInvoice: (data) => dispatch(GenerateExcelInvoice(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrepareInvoice);